export default __webpack_public_path__ + "static/media/heel-main.25b3e732.mp4";